export const resolveBillClientRoute = (grouped)=>{
    if (grouped.agreements.length === 1 && grouped.adHocRelationships.length === 0) {
        return {
            kind: 'direct',
            relationshipId: grouped.agreements[0].id
        };
    }
    return {
        kind: 'preliminary'
    };
};
